import i18next from 'i18next'
import { Map } from 'immutable'
import * as React from 'react'
import { ComponentDidMount, fromJSX, mk_pair, Widget } from 'widgets-for-react'
import { Updater } from "widgets-for-react"
import { dataLayerServices } from '../seo/datalayer'
import { cookiebarClasses, CookiebarLayout, cookiePlaceholderClasses } from './cookiebar.layout'
import { CookieAccepted, CookiebarState, CookieName, CookieState } from './cookiebar.state'
import { getCookie, setConsentCookie, setCookie, updateConsent } from './cookiebar.utils'
import { grantAllConsentTypes, grantMinimalConsentTypes } from '../seo/datalayer.consent'

const translate = (x: string) => i18next.t(x)

const _CookiebarLayout = CookiebarLayout()

export const shouldShowCookies = () => {
  return getCookie('showCookies') !== 'no'
}

export const isCookieAccepted = (cookieName: CookieName): boolean => {
  return getCookie(cookieName) === 'yes'
}

export const cookiebarWidget = (
  state: CookiebarState,
  showSingleCookie: CookieName = undefined as any,
  placeholderText?: string | JSX.Element,
  placeholderButtonLabel?: string
): Widget<Updater<CookiebarState>> => {
  return fromJSX<Updater<CookiebarState>>(
    (setState) => {
      let applyTmpCookies = () =>
        setState((state) => {
          state.tmpCookies.forEach((v: any, n: any) => {
            setConsentCookie(n, v.isAccepted)
          })
          setCookie('showCookies', 'no', 1000)
          let shouldReloadPage = false
          state.tmpCookies.forEach((v: any, k: any) => {
            if (state.Cookies.has(k) && state.Cookies.get(k)?.isAccepted === 'yes' && v.isAccepted === 'no') {
              shouldReloadPage = true
            }
          })
          if (shouldReloadPage) {
            location.reload()
            return { ...state, CookieBarVisible: false }
          }
          return {
            ...state,
            Cookies: state.tmpCookies.toMap(),
            CookieBarVisible: false
          }
        })

      let apply = (cookieAccepted: CookieAccepted) => () =>
        setState((state) => {
          setCookie('showCookies', 'no', 1000)

          if (cookieAccepted == 'yes') {
            grantAllConsentTypes()
            dataLayerServices.cookiesDatalayer(true)
          } else {
            grantMinimalConsentTypes()
            dataLayerServices.cookiesDatalayer(false)
          }

          let updatedCookies: Map<CookieName, CookieState> = state.Cookies.map((cValue: any, cName: any) => {
            setConsentCookie(cName, cookieAccepted)
            return { ...cValue, isAccepted: cookieAccepted }
          }).toMap()
          if (cookieAccepted === 'no') {
            location.reload()
            return { ...state, CookieBarVisible: false }
          }
          return {
            ...state,
            Cookies: updatedCookies,
            CookieBarVisible: false
          }
        })

      let applySingle = (cName: CookieName, cValue: CookieAccepted, useTmp: boolean) =>
        setState((state) => {

          if (useTmp) {
            let cookie = state.tmpCookies.get(cName)
            if (cookie === undefined) console.error('missing cookie in state', cName)
            let updatedCookies: Map<CookieName, CookieState> = state.tmpCookies.set(cName, {
              ...cookie!,
              isAccepted: cValue
            })
            return {
              ...state,
              tmpCookies: updatedCookies
            }
          } else {
            setConsentCookie(cName, cValue)
            let cookie = state.Cookies.get(cName)
            if (cookie === undefined) console.error('missing cookie in state', cName)
            let updatedCookies: Map<CookieName, CookieState> = state.Cookies.set(cName, {
              ...cookie!,
              isAccepted: cValue
            })
            return {
              ...state,
              Cookies: updatedCookies,
              tmpCookies: updatedCookies
            }
          }
        })

      if (showSingleCookie !== undefined) {
        return (
          <_CookiebarLayout.CookiePlaceholderLayout
            text={placeholderText || ''}
            onAccept={() => applySingle(showSingleCookie, 'yes', false)}
            acceptLabel={placeholderButtonLabel || ''}
            options={{ style: cookiePlaceholderClasses }}
            // SVGIcon={{ width: '10px', height: '10px' }}
          />
        )
      }
      if (!state.CookieBarVisible) return <></>
      return (
        <ComponentDidMount onMount={() => {}}>
          <_CookiebarLayout.CookiebarLayout
            onAcceptAll={apply('yes')}
            acceptAllLabel={translate('cookies:cookiebarAcceptCookies')}
            declineAllLabel={translate('cookies:cookiebarDeclineCookies')}
            onDeclineAll={apply('no')}
            onApplySettings={applyTmpCookies}
            applySettingsLabel={translate('cookies:cookiebarChangeSettings')}
            onSetSingle={(name, value) => applySingle(name, value, true)}
            showOptions={state.ExpandOptions}
            showOptionsLabel={translate('cookies:cookiebarShowOptions')}
            toggleOptions={() => setState((s) => ({ ...s, ExpandOptions: !s.ExpandOptions }))}
            title={translate('cookies:cookiebarTitle')}
            intro={translate('cookies:cookiebarIntro')}
            introSettings={translate('cookies:cookiebarIntroSettings')}
            state={state.tmpCookies
              .map((cv: any, cn: any) => mk_pair(cn, cv))
              .valueSeq()
              .toList()}
            options={{ style: cookiebarClasses }}
            // SVGIcon={{ width: '10px', height: '10px' }}
            // ExpandSVGIcon={{ width: '10px', height: '7px' }}
            // SubmitSVGIcon={{ width: '10px', height: '10px' }}
          />
        </ComponentDidMount>
      )
    }
  )
}
